// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s2-0";
export var fileList = "_s2-2";
export var removeFileButton = "_s2-1";